import { connect } from 'react-redux';

import StandardLine from '../../components/sider/standardLine';

export default connect()(StandardLine);



// WEBPACK FOOTER //
// ./containers/sider/standardLine.js